import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IContactMergeRequest {
	targetContactId: string;
	contactIdsToMerge: string[];
}

export function useContactMergeMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IOperationResultNoValue) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ targetContactId, contactIdsToMerge }: IContactMergeRequest) => {
			return new Promise<Api.IOperationResultNoValue>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceWithOperationResults<void>(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: `contact/${targetContactId}/merge`,
					}),
					'POST',
					contactIdsToMerge,
					result => resolve(result),
					error => reject(error)
				);
			});
		},
		onSuccess,
		onError,
	});
}
